import LamborghiniImage from "../Images/Lamborghini (2).png";
import CoffeeImage from "../Images/Coffee.png";
import ProjectK72Image from "../Images/k72.png";
import SahaayakImage from "../Images/Sahaayak.png";
import CrowdFundImage from "../Images/CrowdFund.png";
import FitvoraImage from "../Images/Fitvora.png";
import KairaImage from "../Images/Kaira.png";
import ErikkImage from "../Images/Erikk.png";
import EWS from "../Images/EWS.png"
import FlexboxFanaticsImage from "../Images/FlexboxFanatics.png"




const projects = [
    {
        id: 1,
        title: "EWS",
        image: EWS,
        description: "A full-stack Employee Management System built for secure and efficient employee record management, featuring JWT authentication, CRUD operations, protected routes, and a responsive admin dashboard.",
        liveLink: "https://empyl-management-system.netlify.app/",
        githubLink: "https://github.com/LakhanTekchandani/Employee-Management-System"
    },
    {
        id: 2,
        title: "Flexbox Fanatics",
        image: FlexboxFanaticsImage,
        description: "A responsive UI/UX project created for a design competition, focused on modern visual design, responsive layouts, and an engaging user experience.",
        liveLink: "https://flexbox-fanatics.netlify.app/",
        githubLink: "https://github.com/LakhanTekchandani/flexbox-fanatics"
    },
    {
        id: 3,
        title: "Fitvora",
        image: FitvoraImage,
        description: "A cricket performance platform focused on fitness, nutrition, recovery and athlete development.",
        liveLink: "https://fitvora.netlify.app/",
        githubLink: "https://github.com/LakhanTekchandani/fitvora-elevate-play"
    },
    {
        id: 4,
        title: "CrowdFund",
        image: CrowdFundImage,
        description: "A decentralized crowdfunding platform enabling transparent fundraising through blockchain technology.",
        liveLink: "https://lakhancrowdfunds.netlify.app/",
        githubLink: "https://github.com/LakhanTekchandani/crowdfunds"
    },
    {
        id: 5,
        title: "Sahaayak",
        image: SahaayakImage,
        description: "A social impact platform empowering rural women through mentorship, learning and entrepreneurship opportunities.",
        liveLink: "https://sahaayakincredible.netlify.app/",
        githubLink: "https://github.com/LakhanTekchandani/sahaayak-project"
    },
    {
        id: 6,
        title: "ProjectK72",
        image: ProjectK72Image,
        description: "A modern creative agency landing page focused on immersive visuals, smooth interactions and premium user experience.",
        liveLink: "https://projectk72.netlify.app",
        githubLink: "https://github.com/LakhanTekchandani/k72"
    },
    {
        id: 7,
        title: "Lamborghini Website",
        image: LamborghiniImage,
        description: "A premium automotive landing page showcasing luxury design, performance and immersive user experience.",
        liveLink: "https://incrediblelamborghiniwebsite.netlify.app/",
        githubLink: "https://github.com/LakhanTekchandani/Lamborghini-Web"
    },

    {
        id: 8,
        title: "Coffee Website",
        image: CoffeeImage,
        description: "A modern coffee brand website featuring responsive design, engaging visuals and seamless user experience.",
        liveLink: "https://increadiblecoffeewebsite.netlify.app/",
        githubLink: "https://github.com/LakhanTekchandani/CoffeeStore-Web"
    },
    {
        id: 9,
        title: "Kaira",
        image: KairaImage,
        description:
            "A modern fashion e-commerce landing page focused on clean layouts, product presentation and responsive user experience.",
        liveLink: "https://kairaincrediblesite.netlify.app/",
        githubLink: "https://github.com/LakhanTekchandani/Kaira_website"
    },
    {
        id: 10,
        title: "Erikk",
        image: ErikkImage,
        description:
            "A modern branding agency website featuring bold typography, premium layouts and creative visual storytelling.",
        liveLink: "https://erikkincrediblesite.netlify.app/",
        githubLink: "https://github.com/LakhanTekchandani/Erikk-website"
    }
];

export default projects;
